/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/no-autofocus */

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import AutoComplete from 'react-autocomplete';
import onClickOutside from 'react-onclickoutside';
import { HotKeys } from 'react-hotkeys';
import Spinner from 'components/Spinner';
import AutoCompleteDefaultItem from './AutoCompleteDefaultItem';

import './style.scss';

const keyMap = {
  leave: ['esc', 'tab'],
};

export const AUTO_COMPLETE_MENU_ITEM_TYPE = PropTypes.shape({
  disabled: PropTypes.bool,
  id: PropTypes.string,
  name: PropTypes.string,
});

export class AutoCompleteMenu extends Component {
  static propTypes = {
    autoCompleteItemComponent: PropTypes.oneOfType([
      PropTypes.func,
      PropTypes.object,
      PropTypes.node,
    ]),
    changeValue: PropTypes.func,
    handleClose: PropTypes.func,
    isLoading: PropTypes.bool,
    isOpen: PropTypes.bool,
    item: AUTO_COMPLETE_MENU_ITEM_TYPE,
    itemDisabledReason: PropTypes.string,
    itemIndexOffset: PropTypes.number,
    items: PropTypes.arrayOf(AUTO_COMPLETE_MENU_ITEM_TYPE),
    itemWithIndex: PropTypes.bool,
    placeholder: PropTypes.string,
    renderOverView: PropTypes.func,
    searchTerm: PropTypes.string,
    selectItem: PropTypes.func,
    withAddOption: PropTypes.string,
    onClickAddOption: PropTypes.func,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    withAddOption: null,
    itemIndexOffset: 0,
    onClickAddOption: () => {},
    renderOverView: null,
    autoCompleteItemComponent: AutoCompleteDefaultItem,
  };

  state = {
    position: {},
  };

  keyHandlers = {
    leave: e => this.handleLeave(e),
  };

  componentDidMount() {
    if (this.inputRef) {
      this.getPosition(this.inputRef);
    }
  }

  handleStopEnterPropagation = e => {
    const { isOpen } = this.props;
    if (isOpen) {
      if (e.code === 'Enter') {
        e.stopPropagation();
        e.preventDefault();
      }
    }
  };

  getPosition = ref => {
    const { top, left, width } = ref.getBoundingClientRect();

    this.setState({
      position: {
        top: `${Math.round(top)}px`,
        left: `${Math.round(left + width)}px`,
      },
    });
  };

  matchItemToTerm = (item, value) => {
    if (value === '') {
      return true;
    }

    return item.name.toLowerCase().includes(value.toLowerCase());
  };

  handleInputRef = ref => {
    this.inputRef = ref;
  };

  handleClickOutside = () => {
    const { isOpen, onClose } = this.props;
    if (isOpen) {
      onClose();
    }
  };

  handleLeave = e => {
    e.cancelBubble = true;
    const { searchTerm, changeValue, onClose } = this.props;

    // tab
    if (e.keyCode === 9) {
      onClose();
      return;
    }

    if (searchTerm) {
      changeValue('');
    } else {
      onClose();
    }
  };

  handleGetItemValue = option => option.name;

  handleChange = (event, value) => this.props.changeValue(value);

  handleSelect = (value, option) => this.props.selectItem(option);

  isItemSelectable = ({ disabled }) => !disabled;

  renderMenu = children => {
    const { withAddOption, onClickAddOption, searchTerm } = this.props;

    return (
      <div data-test="autocomplete-menu" styleName="menu">
        {withAddOption && !searchTerm && (
          <div
            data-test="add-option"
            styleName="item"
            onClick={onClickAddOption}
          >
            {withAddOption}
          </div>
        )}
        {children.length ? children : this.renderNoItems()}
      </div>
    );
  };

  renderInput = props => (
    <div ref={this.handleInputRef} styleName="search__container">
      <HotKeys handlers={this.keyHandlers} keyMap={keyMap}>
        <input
          autoFocus
          data-test="menu-input"
          placeholder={this.props.placeholder}
          styleName="search__input"
          {...props}
        />
      </HotKeys>
      {this.props.isLoading && <Spinner isBlue styleName="spinner" />}
    </div>
  );

  renderNoItems() {
    const { isLoading, searchTerm } = this.props;

    if (searchTerm) {
      return (
        <span styleName="item no-items">
          No results found for {`"${searchTerm}"`}
        </span>
      );
    }

    if (!isLoading) {
      return <span styleName="item no-items">No items to show</span>;
    }

    return null;
  }

  render() {
    const {
      items,
      searchTerm,
      isOpen,
      autoCompleteItemComponent: AutoCompleteItemComponent,
      itemWithIndex,
      itemIndexOffset,
      itemDisabledReason,
      renderOverView,
    } = this.props;

    return (
      <AutoComplete
        autoHighlight
        getItemValue={this.handleGetItemValue}
        inputProps={{
          onKeyDown: this.handleStopEnterPropagation,
        }}
        isItemSelectable={this.isItemSelectable}
        items={items}
        open={isOpen}
        renderInput={this.renderInput}
        renderItem={(item, isHighlighted) => (
          <AutoCompleteItemComponent
            key={item.id}
            isHighlighted={isHighlighted}
            item={item}
            itemDisabledReason={itemDisabledReason}
            itemIndexOffset={itemIndexOffset}
            itemWithIndex={itemWithIndex}
            position={this.state.position}
            renderOverView={renderOverView}
            searchTerm={searchTerm}
          />
        )}
        renderMenu={this.renderMenu}
        shouldItemRender={this.matchItemToTerm}
        value={searchTerm}
        wrapperStyle={{ display: 'block', position: 'relative' }}
        onChange={this.handleChange}
        onSelect={this.handleSelect}
      />
    );
  }
}

export default onClickOutside(AutoCompleteMenu);
